<app-table [data]="toolsGrouped"
           [showGroupers]="false"
           [showFilters]="showFilters"
           [isFilterExpanded]="showFilters"
           [showGroupFilters]="showFilters"
           [treeMode]="treeMode"
           [config]="tableConfig"
           [groupFilters]="groupFilters"
           [contextMenuItemsFactory]="contextMenuItemsFactory"
           [rowDuplicate]="true"
           [hasTitle]="hasTitle"
           [rowNewPage]="true"
           [groupableColumns]="groupableColumns"
           [directlyGrouped]="true"
           [isMaterial]="false"
           [rowExpand]="false"
           [filtersToggle]="false"
           [hasSelectAll]="hasSelectAll"
           [isSelectAllChecked]="isSelectAllChecked"
           [isLoading]="isLoading || isLoadingLines || isLoadingEquipments || isLoadingPartNumbers"
           [headerBackgroundColor]="headerBackgroundColor"
           [filterBySecLinesId]="filterBySecLinesId"
           title="{{'admin.tools.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (filterGroupChange)="onFilterGroupChange($event)"
           (filterToggle)="onFilterToggle($event)"
           (duplicateClick)="onDuplicate($event)"
           (openInNewPage)="onOpenToolDetailsInNewPage($event)"
           (pageChange)="onPageChange($event)"
           (selectAll)="onSelectAll()"
           (unSelectAll)="onUnselectAll()" >
    <app-table-column header="{{'admin.tools.table.columns.toolId' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolId' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="id">
        <ng-template #body
                     let-record="record">
            <div *ngIf="selectableTools" class="tool-select">
                <input type="checkbox"
                       (click)="onClickTool($event, record)"
                       *ngIf="hasCheckbox(record)"
                       [checked]="isChecked(record)"
                       [disabled]="isSelectionDisabled(record)"/>
                <span>{{ record?.id }}</span>
            </div>
            <span *ngIf="!selectableTools">{{ record?.id }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolName' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolName' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolUid' | translate}}"
                      field="toolUid">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input [(ngModel)]="column.filterValue"
                       placeholder="{{'admin.tools.table.filters.toolUid' | translate}}"
                       (inputChange)="onToolUidChange(table, column, $event)"></app-input>
        </ng-template>
        <ng-template #body
                     let-record="record">
            <div [class.tool-set]="isToolSet(record)">
                {{ isToolSet(record) ? 'SET' : record.toolUid }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.mesCode' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.mesCode' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="mesCode">
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.supplierCode' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.supplierCode' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="supplierCode">
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolStatus' | translate}}"
                      field="status">
        <ng-template #body let-record="record">
            <span class="status-row">
            <app-tooltip *ngIf="record?.stance" type="info" [record]="record?.stance"></app-tooltip>
                {{ record?.status }}
                </span>
        </ng-template>
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterStatusList"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.tools.table.filters.toolStatus.placeholder' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolAvailable.header' | translate}}"
                      field="availabilityStatus">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterAvailableForManufacturingList"
                          displayField="name"
                          valueField="value"
                          emptyText="{{'admin.tools.table.filters.toolAvailable' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-record="record">
            <span *ngIf="isToolSet(record) || isGroup(record)"
                  class="tool"
                  [class.available]="record?.isAvailable === 'available'"
                  [class.partially-available]="record?.isAvailable === 'partiallyAvailable'"
                  [class.unavailable]="record?.isAvailable === 'unavailable'">
                {{
                    (record.isAvailable === 'available' ? 'admin.tools.table.columns.toolAvailable.available' :
                        (record.isAvailable === 'unavailable' ? 'admin.tools.table.columns.toolAvailable.unavailable' :
                            'admin.tools.table.columns.toolAvailable.partiallyAvailable')) | translate
                }}
            </span>
            <span *ngIf="!isToolSet(record) && !isGroup(record)"
                  class="tool {{record.isAvailableForManufactoring ? 'available' : 'unavailable'}}">
                 {{ (record.isAvailableForManufactoring ? 'admin.tools.table.columns.toolAvailable.available' : 'admin.tools.table.columns.toolAvailable.unavailable') | translate }}
             </span>
        </ng-template>
    </app-table-column>
    <app-table-column cls="action">
        <ng-template #body
                     let-record="record">
            <a *ngIf="!record.children"
               class="waves-effect btn-flat"
               (click)="openToolDetails(record)">
                <i class="material-icons">open_in_new</i>
            </a>
        </ng-template>
    </app-table-column>
</app-table>
